// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3YHnN","title":"card_title__21Uhj","inActive":"card_inActive__ws1ci"};